export const PATHS = {
  BUY_REQUIREMENT_PATH: "/buyers",
  SELL_REQUIREMENT: "/sellers",
  // PRODUCTS_PATH: "/products",
  BUY_REQUIREMENT_WITH_COMMODITY: "/buyers/:commodity",
  SELL_REQUIREMENT_WITH_COMMODITY: "/sellers/:commodity",
  // AUCTIONS_WITH_COMMODITY: "/auctions/:commodity",
  PRODUCTS_WITH_COMMODITY: "/products/:commodity",
};
